import React, { useContext, useState, useRef, useEffect } from "react";
import "./style.scss";
import moment from "moment";
import { StoreContext } from "../../store/store";
import { Link, withRouter } from "react-router-dom";
import Linkify from 'linkify-react';
import {
  ICON_REPLY,
  ICON_HEART,
  ICON_CLOSE,
  ICON_ARROWBACK,
  ICON_PLUS,
  ICON_MINUS,
} from "../../Icons";
import axios from "../../axiosLib";
import { API_URL } from "../../config";
import ContentEditable from "react-contenteditable";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import dayjs from "dayjs";
import { useLocalization } from "../../hooks/useLocalization";
import FollowButton from "../Profile/FollowButton";
import { getDatetimeFormat, checkIfTextIsJa, getLangCodeFromLangString, timeDisplay, optimizeInstagramSize } from "../../utils/common";
import UserAvatar from "../UserAvatar";
import { IoIosFlag } from "react-icons/io";
import { BsInfoCircle } from "react-icons/bs";
import InformModal from '../InformModal';
import Tooltip from '../Tooltip';
import EditCarvibesModal from '../EditCarvibes';
import { FaShareAlt } from "react-icons/fa";
import html2canvas from "html2canvas";
import Loading from '../loading';

const SCREEN_TEXT = ["投稿する", "いいね！が付いています", "返事"];

const CarvibesCard = React.memo(function CarvibesCard(props) {
  const { state, actions } = useContext(StoreContext);
  const { account, session, user } = state;
  const { countryCode, translatedTexts } = useLocalization(SCREEN_TEXT);

  const [translatedDescription, setTranslatedDescription] = useState(props.description);
  const [likedByText, setLikedByText] = useState(translatedTexts[1]);
  const [translationAlert, setTranslationAlert] = useState("");
  const [deleteCarvibesId, setDeleteCarvibesId] = useState("");
  const [likePending, setLikePending] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [popUpImageSrc, setPopUpImageSrc] = useState("");
  const [likesOpen, setLikesOpen] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replyImage, setReplyImg] = useState(null);
  const [parent, setParent] = useState(false);
  const [styleBody, setStyleBody] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [composing, setComposing] = useState(false);
  const [reported, setReported] = useState(props.reported);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [selectedCarvibesForReport, setSelectedCarvibesForReport] = useState("");
  const [editCarvibesData, setEditCarvibesData] = useState(null);
  const [replyingToComment, setReplyingToComment] = useState(null);
  const [commentLikePending, setCommentLikePending] = useState({});
  const [isGeneratingImage, setIsGeneratingImage] = useState(false);
  const [generatedImageUrl, setGeneratedImageUrl] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const cardRef = useRef(null);
  const MAX_STRING_LENGTH = 140;

  // Recursive function to count all nested replies
  const countAllReplies = (replies) => {
    if (!replies || replies.length === 0) return 0;

    let count = replies.length;
    replies.forEach(reply => {
      if (reply.replies && reply.replies.length > 0) {
        count += countAllReplies(reply.replies);
      }
    });

    return count;
  };

  // Memoize the total reply count for performance
  const totalReplyCount = React.useMemo(() => {
    return countAllReplies(props.replies);
  }, [props.replies]);

  let info;
  const likeCarvibes = async (e, id) => {
    e.stopPropagation();

    if (likePending) return;
    setLikePending(true);
    if (!session) {
      actions.alert("Please Sign In");
      return;
    }
    if (props.history.location.pathname.slice(1, 5) === "prof") {
      info = { dest: "profile", id };
    } else {
      info = { id };
    }
    await actions.likeCarvibes(info);
    await actions.verifyToken("get account");
    setLikePending(false);
  };

  const onReport = (e, id) => {
    e.stopPropagation();

    setReportModalOpen(true);
    setSelectedCarvibesForReport(id);
  }

  const reportCarvibes = () => {
    const id = selectedCarvibesForReport;

    if (!session) {
      actions.alert("Please Sign In");
      return;
    }

    if (!id) {
      return;
    }
    if (props.history.location.pathname.slice(1, 5) === "prof") {
      info = { dest: "profile", id };
    } else {
      info = { id, user: props.user._id };
    }
    actions.reportCarvibes(info);
    setReported(true);

    setReportModalOpen(false);
    setSelectedCarvibesForReport("");
  };

  const deleteCarvibes = (e, id) => {
    e.stopPropagation();
    actions.deleteCarvibes(id);
  };

  const toggleModal = (e, type) => {
    if (e) {
      e.stopPropagation();
    }
    if (!session) {
      actions.alert("Please Sign In");
      return;
    }
    setStyleBody(!styleBody);
    if (type === "parent") {
      setParent(true);
    } else {
      setParent(false);
    }
    setTimeout(() => {
      setModalOpen(!modalOpen);
      if (!modalOpen) {
        document.documentElement.classList.add("scroll-disabled");
      } else {
        document.documentElement.classList.remove("scroll-disabled");
      }
    }, 20);
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const navigateToPostDetail = (e, id) => {
    e.stopPropagation();
    console.log(id)
    props.history.push(`/post/${props.id}`);
  }

  const carvibesT = useRef("");
  const composition = useRef("");

  const handleChange = (evt) => {
    var preservedText = evt.target.value.replace(/(?:\r\n|\r|\n)/g, "<br>");
    composition.current = preservedText;
    if (composing) return;
    carvibesT.current = composition.current;
    setReplyText(carvibesT.current);
  };

  const handleTranslateDescription = async (text) => {
    const lang = localStorage.getItem("lang");
    const langCode = getLangCodeFromLangString(lang);

    // Extracting links, <br /> elements, and \n
    const elements = [];
    const placeholder = "\uFFFC";

    const regex = /(\s*)(<a\b[^>]*>(.*?)<\/a>|https?:\/\/[^\s]+|<br\s*\/?>|\n)(\s*)/gi;
    let cleanText = text.replace(regex, (match, leadingSpace, element, content, trailingSpace) => {
      elements.push(leadingSpace + element + trailingSpace);
      return placeholder;
    });

    if (!checkIfTextIsJa(cleanText) || !checkIfTextIsJa(likedByText)) {
      setTranslationAlert('Text is not in Japanese');
      return;
    }

    if (langCode === 'ja') {
      setTranslationAlert('母国語が日本語のため翻訳できません.');
      return;
    }

    // set language if its different from the current one.
    if (user && user.nativeLang !== langCode && lang) {
      actions.updateUser({
        nativeLang: langCode,
        _id: account._id,
      });
    }

    const values = {
      content: cleanText.trim(),
      lang: langCode,
    };

    // translate the likedBy string separately
    let translatedLikedByText;
    try {
      const response = await axios.post(`${API_URL}/translate/liked-by`, { lang: langCode });
      translatedLikedByText = response.data.translation;
    } catch (err) {
      console.error(`Translation error: ${JSON.stringify(err)}`);
      setTranslationAlert('Translation error');
    }

    try {
      const response = await axios.post(`${API_URL}/translate/carvibes`, values);
      let translatedDescription = response.data.translation;

      // Reinsert links, <br />, and \n back into the translated text
      translatedDescription = translatedDescription.replace(new RegExp(placeholder, 'g'), () => elements.shift());

      setLikedByText(translatedLikedByText)
      setTranslatedDescription(translatedDescription);
    } catch (err) {
      console.error(`Translation error: ${JSON.stringify(err)}`);
      setTranslationAlert('Translation error');
    }

  };

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      document.getElementsByTagName("body")[0].style.cssText =
        styleBody && "overflow-y: hidden; margin-right: 17px";
    }
  }, [styleBody]);

  useEffect(
    () => () => (document.getElementsByTagName("body")[0].style.cssText = ""),
    []
  );

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (document.getElementById("replyBox")) {
      document.getElementById("replyBox").focus();
    }
  }, [modalOpen]);

  const replyCarvibes = async (type) => {
    if (!replyText.length) {
      return;
    }
    let hashtags = replyText.match(/#(\w+)/g);
    const values = {
      description: replyText,
      images: [replyImage],
      parent:
        replyingToComment
          ? replyingToComment._id
          : type === "parent"
            ? props.parent._id
            : type === "recarvibes"
              ? props.recarvibes._id
              : props.id,
      hashtags,
    };
    if (values.parent.length === 0) return;
    if (!session) {
      actions.alert("Please Sign In");
      return;
    }

    const parentId = replyingToComment ? props.id : values.parent;

    if (replyingToComment) {
      setReplyingToComment(null);
    } else {
      toggleModal();
    }

    // Submit the comment first
    await actions.carvibes(values);
    await actions.verifyToken("get account");

    // Then refresh the post to show the new comment
    setTimeout(() => {
      props.carvibesUpdated(parentId);
    }, 800);

    carvibesT.current = "";
    setReplyText("");
    setReplyImg(null);
    actions.alert("Carvibes sent!");
  };

  const shareCarvibes = async (e) => {
    e.stopPropagation();

    if (!cardRef.current) {
      actions.alert("Failed to generate image. Please try again.");
      return;
    }

    setIsGeneratingImage(true);

    try {
      // Get the actual rendered width of the card on screen to match display exactly
      const cardRect = cardRef.current.getBoundingClientRect();
      const actualCardWidth = cardRect.width;
      
      const canvas = await captureForShare(cardRef.current, { width: actualCardWidth });
      const instagramCanvas = optimizeInstagramSize(canvas);

      const blob = await canvasToBlob(instagramCanvas, 'image/png', 0.95);

      if (!blob) {
        setIsGeneratingImage(false);
        actions.alert("Image generation failed. Please try again.");
        return;
      }

      const imageUrl = URL.createObjectURL(blob);
      setGeneratedImageUrl(imageUrl);
      setShowPreviewModal(true);
      setIsGeneratingImage(false);
    } catch (error) {
      setIsGeneratingImage(false);
      actions.alert("Failed to generate image. Please try again.");
    }
  };

  // This is the function for integrating with web share api.
  // Need to update
  const handleConfirmShare = async () => {
    if (!generatedImageUrl) return;

    try {
      const response = await fetch(generatedImageUrl);
      const blob = await response.blob();

      const file = new File([blob], 'carvibes-share.png', { type: blob.type || 'image/png' });

      const result = await shareFile(file, props.id);

      if (result.ok || result.reason === 'cancelled') {
        handleClosePreview();
        return;
      }

      if (result.reason === 'not_mobile') {
        actions.alert("Sharing works on mobile browsers. Please open on your phone.");
        return;
      }

      if (result.reason === 'unsupported') {
        actions.alert("Sharing is not supported on this device/browser.");
        return;
      }

      actions.alert("Failed to share. Please try again.");
    } catch (error) {
      actions.alert("Failed to share. Please try again.");
    }
  };

  const handleClosePreview = () => {
    if (generatedImageUrl) {
      URL.revokeObjectURL(generatedImageUrl);
    }
    setGeneratedImageUrl(null);
    setShowPreviewModal(false);
  };

  const isProbablyMobile = () => {
    if (typeof window === 'undefined') return false;
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  const canWebShareFiles = (file) => {
    if (typeof navigator === 'undefined') return false;
    if (!navigator.share) return false;
    if (!navigator.canShare) return true;

    try {
      return navigator.canShare({ files: [file] });
    } catch {
      return false;
    }
  };

  const shareFile = async (file, id) => {
    if (!isProbablyMobile()) {
      return { ok: false, reason: 'not_mobile' };
    }

    if (!canWebShareFiles(file)) {
      return { ok: false, reason: 'unsupported' };
    }

    const url = `${process.env.REACT_APP_FRONTEND_URL}/post/${id}`;

    try {
      await navigator.share({
        title: 'Carvibes',
        text: url,
        files: [file],
      });
      return { ok: true };
    } catch (error) {
      if (error?.name === 'AbortError') {
        return { ok: false, reason: 'cancelled' };
      }
      return { ok: false, reason: 'failed', error };
    }
  };

  const canvasToBlob = (canvas, type = 'image/png', quality) => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), type, quality);
    });
  };

  const captureForShare = async (node, { width } = {}) => {
    // Get actual rendered dimensions from the original node to match screen display
    const originalRect = node.getBoundingClientRect();
    const actualWidth = width || originalRect.width;
    
    const clone = node.cloneNode(true);

    const wrapper = document.createElement("div");
    wrapper.style.position = "fixed";
    wrapper.style.left = "-10000px";
    wrapper.style.top = "0";
    wrapper.style.width = `${actualWidth}px`; // Use actual rendered width
    wrapper.style.background = "#ffffff";
    wrapper.style.padding = "0";
    wrapper.style.margin = "0";
    wrapper.style.zIndex = "-1";

    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);
    
    // Get actual image container width from original node to match screen display exactly
    const originalImageContainer = node.querySelector('div[style*="height: 350px"]');
    let originalImageContainerWidth = null;
    if (originalImageContainer) {
      const originalImageRect = originalImageContainer.getBoundingClientRect();
      originalImageContainerWidth = originalImageRect.width;
    }
    
    // Preserve the actual card wrapper width to match screen display
    const cardWrapper = clone.querySelector('.Carvibes-card-wrapper');
    if (cardWrapper) {
      // Get the actual width from the original node
      const originalCardWrapper = node.querySelector('.Carvibes-card-wrapper');
      if (originalCardWrapper) {
        const originalCardRect = originalCardWrapper.getBoundingClientRect();
        cardWrapper.style.width = `${originalCardRect.width}px`;
        cardWrapper.style.maxWidth = `${originalCardRect.width}px`;
      }
    }

    // Wait for all images to load and ensure aspect ratio is preserved
    const images = clone.querySelectorAll('img');
    const imageLoadPromises = Array.from(images).map((img) => {
      return new Promise((resolve) => {
        if (img.complete && img.naturalWidth > 0) {
          resolve();
        } else {
          const timeout = setTimeout(resolve, 5000); // Timeout after 5 seconds
          img.onload = () => {
            clearTimeout(timeout);
            resolve();
          };
          img.onerror = () => {
            clearTimeout(timeout);
            resolve(); // Resolve even on error to not block
          };
        }
      });
    });

    await Promise.all(imageLoadPromises);

    // First, ensure .card-image-link container has proper constraints
    const cardImageLinks = clone.querySelectorAll('.card-image-link');
    cardImageLinks.forEach((linkContainer) => {
      linkContainer.style.position = 'relative';
      linkContainer.style.width = '100%';
      linkContainer.style.overflow = 'hidden'; // Critical: clip overflow to crop image
      linkContainer.style.borderRadius = '14px';
    });

    // Ensure .card-content-images container also clips properly
    const cardContentImages = clone.querySelectorAll('.card-content-images');
    cardContentImages.forEach((container) => {
      container.style.overflow = 'hidden'; // Ensure clipping
      container.style.width = '100%';
    });

    // Ensure Carousel root element is properly constrained
    const carousels = clone.querySelectorAll('.carousel');
    carousels.forEach((carousel) => {
      carousel.style.width = '100%';
      carousel.style.height = '350px';
      carousel.style.overflow = 'hidden';
      carousel.style.position = 'relative';
    });

    // Find image containers and ensure images maintain cover and center styling like on web
    // Look for the div with inline style height: 350px (the image container)
    const heightContainers = clone.querySelectorAll('div[style*="height: 350px"], div[style*="height:350px"]');
    heightContainers.forEach((heightContainer) => {
      // Keep container at fixed height and full width to match web view
      heightContainer.style.width = '100%';
      heightContainer.style.height = '350px'; // Keep fixed height like web view
      heightContainer.style.overflow = 'hidden'; // Critical: hide overflow to crop image
      heightContainer.style.position = 'relative'; // Ensure proper positioning context
      // Apply border radius to container to match web view styling
      heightContainer.style.borderRadius = '14px';
      heightContainer.style.borderBottomLeftRadius = '14px';
      heightContainer.style.borderBottomRightRadius = '14px';
    });

    // Ensure Report button and share container are visible during capture
    const shareAndReportContainers = clone.querySelectorAll('.share-and-report-container');
    shareAndReportContainers.forEach((container) => {
      container.style.display = 'flex';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      container.style.position = 'relative';
      container.style.zIndex = '1';
      
      // Ensure Report button is visible
      const reportButtons = container.querySelectorAll('.report-button, .card-button-wrap.report-button');
      reportButtons.forEach((btn) => {
        btn.style.display = 'flex';
        btn.style.visibility = 'visible';
        btn.style.opacity = '1';
        btn.style.position = 'relative';
        btn.style.zIndex = '1';
      });
    });

    // Force a layout recalculation to get accurate dimensions
    void clone.offsetHeight; // Force reflow
    
    // Wait for styles to apply and layout to settle
    await new Promise(resolve => setTimeout(resolve, 200));

    // NOW calculate and apply cover dimensions - html2canvas doesn't respect object-fit: cover
    // We need to manually calculate dimensions to achieve cover behavior matching screen display
    const carouselSlides = clone.querySelectorAll('.carousel .slide');
    carouselSlides.forEach((slide) => {
      // Ensure slide container is properly sized and clips overflow
      slide.style.width = '100%';
      slide.style.height = '350px';
      slide.style.overflow = 'hidden';
      slide.style.position = 'relative';
      slide.style.display = 'block';
      
      const slideImages = slide.querySelectorAll('img');
      slideImages.forEach((img) => {
        if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
          // Get container dimensions after layout - use actual rendered width from screen
          const containerRect = slide.getBoundingClientRect();
          // Force a reflow to get accurate dimensions
          void slide.offsetWidth;
          // Use original image container width if available, otherwise use calculated width
          const containerWidth = originalImageContainerWidth || containerRect.width || slide.offsetWidth || actualWidth;
          const containerHeight = 350;
          
          if (containerWidth > 0) {
            // Calculate cover dimensions: image should fill container while maintaining aspect ratio
            const imgAspect = img.naturalWidth / img.naturalHeight;
            const containerAspect = containerWidth / containerHeight;
            
            let finalWidth, finalHeight, offsetX = 0, offsetY = 0;
            
            if (imgAspect > containerAspect) {
              // Image is wider - fit to height, crop width
              finalHeight = containerHeight;
              finalWidth = containerHeight * imgAspect;
              offsetX = (containerWidth - finalWidth) / 2; // Center horizontally
            } else {
              // Image is taller - fit to width, crop height
              finalWidth = containerWidth;
              finalHeight = containerWidth / imgAspect;
              offsetY = (containerHeight - finalHeight) / 2; // Center vertically
            }
            
            // Set calculated dimensions to achieve cover effect
            img.style.width = `${finalWidth}px`;
            img.style.height = `${finalHeight}px`;
            img.style.position = 'absolute';
            img.style.top = `${offsetY}px`;
            img.style.left = `${offsetX}px`;
            img.style.objectFit = 'none'; // Disable object-fit, we're doing it manually
            img.style.display = 'block';
            // Apply border radius to match web view styling
            img.style.borderRadius = '14px';
            img.style.borderBottomLeftRadius = '14px';
            img.style.borderBottomRightRadius = '14px';
          }
        }
      });
    });
    

    const canvas = await html2canvas(clone, {
      backgroundColor: "#ffffff",
      scale: 2,
      useCORS: true,
      logging: false,
      width: clone.scrollWidth,
      height: clone.scrollHeight,
      windowWidth: width,
    });

    document.body.removeChild(wrapper);
    return canvas;
  };

  moment.updateLocale("en", {
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "few seconds ago",
      ss: "%ss",
      m: "1m",
      mm: "%dm",
      h: "1h",
      hh: "%dh",
      d: "a day",
      dd: "%dd",
      M: "a month",
      MM: "%dM",
      y: "a year",
      yy: "%dY",
    },
  });

  useEffect(() => {
    if (typeof window != "undefined") {
      if (popUpImageSrc !== "") {
        document.documentElement.classList.add("scroll-disabled");
      } else {
        document.documentElement.classList.remove("scroll-disabled");
      }
    }
  }, [popUpImageSrc]);

  if (!props.parent && !props.user) {
    return null;
  }

  return (
    <div className="Carvibes-card-root">
      {props.parent ? (
        <div
          onClick={(e) => toggleModal(e)}
          key={props.parent._id}
          style={{ borderBottom: "0px" }}
          className="Carvibes-card-wrapper"
        >
          <div
            style={{ display: "flex", flexDirection: "column" }}
            className="card-userPic-wrapper"
          >
            {props.parent.parent ? (
              <div style={{ marginTop: "17px" }}></div>
            ) : null}
            <Link
              onClick={(e) => e.stopPropagation()}
              to={`/profile/${props.parent.user._id}`}
            >
              <UserAvatar user={props.parent.user} />
            </Link>
            <div className="card-content-header">
              <div className="card-header-detail">
                <span className="card-header-user">
                  <Link
                    onClick={(e) => e.stopPropagation()}
                    to={`/profile/${props.parent.user._id}`}
                  >
                    {props.parent.user.name}
                  </Link>
                </span>
              </div>
              <div className="card-header-more"></div>
            </div>
            <div className="carvibes-reply-thread"></div>
          </div>
          <div className="card-content-wrapper">
            {props.parent.images[0] && (
              <div className="card-content-images">
                <div className="card-image-link">
                  <img alt="" src={props.parent.images[0]} />
                </div>
              </div>
            )}
            <div className="card-buttons-wrapper">
              <div
                onClick={(e) => {
                  likeCarvibes(e, props.parent._id);
                  setTimeout(() => {
                    props.carvibesUpdated(props.parent._id);
                  }, 500);
                }}
                className="card-button-wrap heart-wrap"
              >
                <div className="card-icon heart-icon">
                  <ICON_HEART />
                </div>
                <div className="card-icon-value">
                  {props.parent.likes.length}
                </div>
              </div>
              <div
                onClick={(e) => {
                  if (props.parent._id.length !== 0) toggleModal(e, "parent");
                }}
                className="card-button-wrap reply-wrap"
              >
                <div className="card-icon reply-icon">
                  <ICON_REPLY styles={{ fill: "rgb(101, 119, 134)" }} />
                </div>
                <div className="card-icon-value">
                  {props.parent.replies.length > 0 &&
                    props.parent.replies.length}
                </div>
              </div>
            </div>
            <div
              className="card-content-info"
              style={{ whiteSpace: "pre-wrap" }}
            >
              <Linkify
                options={{ className: 'link-text', target: '_blank' }}
              >
                {props.parent.description
                  .replaceAll("<br>", "\n")
                  .replaceAll("<br />", "\n")
                  .replaceAll("<br/>", "\n")
                  .substr(0, MAX_STRING_LENGTH) + "\u2026"}
              </Linkify>
              <br />
              {timeDisplay(props.parent.createdAt)}
            </div>
          </div>
        </div>
      ) : null}

      {props.user ? (
        <div
          ref={cardRef}
          key={props.id}
          className="Carvibes-card-wrapper"
          onClick={(e) => navigateToPostDetail(e, props.id)}
        >
          <div className="card-userPic-wrapper">
            <Link
              onClick={(e) => e.stopPropagation()}
              to={`/profile/${props.user._id}`}
            >
              <UserAvatar user={props.user} />
            </Link>
            <div className="card-content-header">
              <div className="card-header-detail">
                <span className="card-header-user">
                  <Link
                    onClick={(e) => e.stopPropagation()}
                    to={`/profile/${props.user._id}`}
                  >
                    {props.user.name}
                  </Link>
                </span>
              </div>
              <div className="card-header-more"></div>
            </div>
            {account ? <FollowButton user={props.user} show={props.showFollow} /> : null}
            {account && props.user._id === account._id && props.showEdit ?
              <div className="edit-delete-container">
                <div className='translate-button'
                  style={{ marginLeft: "auto", marginRight: "10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditCarvibesData(props);
                  }}
                >
                  編集
                </div>
                <div className='translate-button'
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteCarvibesId(props.id);
                  }}
                >
                  削除
                </div>
              </div> : null}
          </div>
          <div className="card-content-wrapper">
            {props.images && props.images[0] && (
              <div className="card-content-images">
                <div className="card-image-link">
                  <div
                    style={{
                      width: "Calc( 100% - 0.5px )",
                      height: "350px",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Carousel
                      className="slider"
                      emulateTouch
                      showThumbs={false}
                      showStatus={false}
                      onClickItem={(index, item) => setPopUpImageSrc(item.key)}
                    >
                      {props.images.map((image) => {
                        return (
                          <img
                            alt=""
                            key={image}
                            src={image}
                            role="presentation"
                          />
                        );
                      })}
                    </Carousel>
                  </div>
                </div>
              </div>
            )}
            <div className="card-buttons-wrapper">
              <div
                onClick={(e) => {
                  likeCarvibes(e, props.id);
                  setTimeout(() => {
                    props.carvibesUpdated(props.id);
                  }, 500);
                }}
                className="card-button-wrap heart-wrap"
              >
                <div className="card-icon heart-icon">
                  <ICON_HEART />
                </div>
                <div className="card-icon-value">{props.likes.length}</div>
              </div>

              <div
                onClick={(e) => {
                  if (props.id.length !== 0) toggleModal(e);
                }}
                className="card-button-wrap reply-wrap"
                style={{
                  display: `${props.noComment ? 'none' : 'flex'}`
                }}
              >
                <div className="card-icon reply-icon">
                  <ICON_REPLY styles={{ fill: "rgb(101, 119, 134)" }} />
                </div>
                <div
                  className="card-icon-value"
                  style={{ width: '30px' }}
                >
                  {totalReplyCount > 0 && totalReplyCount}
                </div>
              </div>

              {
                props.showReport ?
                  <div className='share-and-report-container'>
                    <div className={
                      reported ? "card-button-wrap" : "card-button-wrap report-button"
                    }
                      style={{ marginLeft: "auto" }}
                      onClick={(e) => {
                        if (reported || !session) return;
                        if (props.id.length !== 0) onReport(e, props.id);
                      }}
                    >
                      {reported ? <IoIosFlag style={{
                        fill: reported ? "red" : "rgb(0, 0, 0)",
                      }} />
                        : "Report"}
                    </div>
                    <FaShareAlt className='share-icon' size={20} onClick={shareCarvibes} />
                  </div>
                  : null
              }
            </div>
            <div
              className="card-likes-exist"
              onClick={() => setLikesOpen(!likesOpen)}
            >
              {props.likes.length > 0
                ? likedByText +
                " ：" +
                props.likes
                  .map((likedBy) => likedBy.name)
                  .join(" ,")
                  .substr(0, MAX_STRING_LENGTH) +
                "\u2026"
                : ""}
            </div>
            <div className="card-content-info">
              <div className='carvibes-content-section'>
                <p>
                  <Linkify
                    options={{ className: 'link-text', target: '_blank' }}
                  >
                    {showMore
                      ? translatedDescription
                      : translatedDescription
                        .replaceAll("<br>", "\n")
                        .replaceAll("<br />", "\n")
                        .replaceAll("<br/>", "\n")
                        .substr(0, MAX_STRING_LENGTH) +
                      (translatedDescription.length > MAX_STRING_LENGTH
                        ? "\u2026"
                        : "")}
                  </Linkify>
                </p>
                {translatedDescription.length > MAX_STRING_LENGTH ? (
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                    onClick={() => {
                      setShowMore(!showMore);
                    }}
                  >
                    {showMore ? (
                      <ICON_MINUS styles={{ fill: "rgb(101, 119, 134)" }} />
                    ) : (
                      <ICON_PLUS styles={{ fill: "rgb(101, 119, 134)" }} />
                    )}
                  </div>
                ) : null}
                {props.isTranslationEnabled ?
                  <div className='translate-button-section'>
                    <div
                      onClick={(e) => handleTranslateDescription(translatedDescription)}
                      className='translate-button'
                    >
                      翻訳
                    </div>
                    <Tooltip
                      content={
                        <>
                          翻訳機能は日本語の投稿を多言語に翻訳する機能となります
                          <br />
                          This is a function to translate the Japanese translation function into multiple languages.
                        </>
                      }
                      direction="left"
                    >
                      <BsInfoCircle data-tooltip-id="my-tooltip-2" className='translate-tooltip' fontSize={24} />
                    </Tooltip>
                  </div>
                  : null
                }

              </div>
              <br />
              <div className='carvibes-time-display'>
                {timeDisplay(props.createdAt)}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {props.parent || props.user ? (
        <div
          style={{ display: likesOpen ? "block" : "none" }}
          className="modal-edit"
        >
          {likesOpen ? (
            <div
              style={{ minHeight: "500px", height: "initial" }}
              className="modal-content"
            >
              <div className="modal-header">
                <p className="modal-title">CarVibesリスト</p>
                <div
                  onClick={() => setLikesOpen(!likesOpen)}
                  className="modal-closeIcon-wrap"
                >
                  <ICON_CLOSE />
                </div>
              </div>
              <div
                style={{ marginTop: "3em", marginLeft: "20px" }}
                className="modal-body"
              >
                {props.likes.map((likedBy) => (
                  <Link
                    onClick={(e) => e.stopPropagation()}
                    to={`/profile/${likedBy._id}`}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "10px"
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            marginRight: "10px",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            src={likedBy.profileImg}
                            alt=""
                          />
                        </div>
                        <div>
                          <p>
                            {likedBy && likedBy.name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      {props.parent || props.user ? (
        <div
          onClick={() => toggleModal()}
          style={{ display: modalOpen ? "block" : "none" }}
          className="modal-edit"
        >
          {modalOpen ? (
            <div
              style={{ minHeight: "500px", height: "initial" }}
              onClick={(e) => handleModalClick(e)}
              className="modal-content"
            >
              <div className="modal-header">
                <div className="modal-closeIcon">
                  <div
                    onClick={() => toggleModal()}
                    className="modal-closeIcon-wrap"
                  >
                    <ICON_ARROWBACK />
                  </div>
                </div>
                <p className="modal-title">{translatedTexts[2]}</p>
              </div>
              <div style={{ marginTop: "10px" }} className="modal-body">
                <div className="reply-content-wrapper">
                  <div className="card-content-wrapper-2">
                    {props?.replies?.map((r, i) => {
                      return (
                        <div
                          style={{ marginTop: "5px", marginBottom: "20px" }}
                          key={i + "__replies"}
                        >
                          <div className="card-userPic-wrapper">
                            <UserAvatar user={r?.user} />
                            <div className="card-content-header">
                              <div className="card-header-detail">
                                <span className="card-header-user">
                                  <Link
                                    onClick={(e) => e.stopPropagation()}
                                    to={`/profile/${r._id}`}
                                  >
                                    {r.name}
                                  </Link>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="card-content-info"
                            style={{
                              marginTop: "5px",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html: r.description
                                  .replaceAll("<br>", "\n")
                                  .replaceAll("<br />", "\n")
                                  .replaceAll("<br/>", "\n"),
                              }}
                            />
                            < br />
                            {timeDisplay(r.createdAt)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  style={{ position: "relative", backgroundColor: "white" }}
                  className="Carvibes-input-wrapper"
                >
                  {replyingToComment && (
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: "#f0f8ff",
                        borderLeft: "3px solid #1da1f2",
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <span style={{ fontSize: "12px", color: "#657786" }}>
                          返信先:
                        </span>
                        <span style={{ fontSize: "14px", fontWeight: "bold", marginLeft: "5px" }}>
                          {replyingToComment.name}
                        </span>
                      </div>
                      <div
                        onClick={() => setReplyingToComment(null)}
                        style={{
                          cursor: "pointer",
                          color: "#657786",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        ×
                      </div>
                    </div>
                  )}
                  <div className="Carvibes-profile-wrapper">
                    <div>
                      <UserAvatar user={account} />
                    </div>
                  </div>
                  <div
                    onClick={() => document.getElementById("replyBox").focus()}
                    className="Carvibes-input-side"
                  >
                    <div className="inner-input-box">
                      <ContentEditable
                        id="replyBox"
                        style={{ minHeight: "30px", minWidth: "100px" }}
                        className={
                          replyText.length ? "carvibes-input-active" : null
                        }
                        placeholder="Reply"
                        html={carvibesT.current}
                        onChange={handleChange}
                        onFocus={(e) => {
                          // Mobile browsers don't auto-scroll contenteditable
                          // elements above the keyboard like they do for inputs/textareas.
                          setTimeout(() => {
                            e.target.scrollIntoView({ behavior: "smooth", block: "center" });
                          }, 300);
                        }}
                        onCompositionStart={setComposing.bind(null, true)}
                        onCompositionEnd={(evt) => {
                          setComposing(false);
                          handleChange({
                            target: { value: composition.current },
                          });
                        }}
                      />
                    </div>
                    <div
                      className="inner-input-links"
                      style={{
                        background: "white",
                        margin: "0px",
                        justifyContent: "end",
                      }}
                    >
                      <div className="carvibes-btn-holder">
                        <div
                          onClick={() =>
                            replyCarvibes(
                              parent
                                ? "parent"
                                : props.recarvibes
                                  ? "recarvibes"
                                  : "none"
                            )
                          }
                          className={
                            replyText.length
                              ? "carvibes-btn-side carvibes-btn-active"
                              : "carvibes-btn-side"
                          }
                        >
                          {translatedTexts[0]}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      {props.clickableImage && props.user && popUpImageSrc !== "" ? (
        <div
          onClick={() => {
            setPopUpImageSrc("");
          }}
          className="carousel-modal-container"
        >
          <div
            id="imageCarouselModal"
            className="image-carousel-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <img
              alt=""
              src={popUpImageSrc}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>
      ) : null}

      {reportModalOpen ? (
        <div
          className="modal-edit"
          onClick={() => {
            setReportModalOpen(false);
            setSelectedCarvibesForReport("");
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              width: "350px",
              height: "175px",
              textAlign: "center",
              display: reportModalOpen ? "block" : "none"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <p style={{
                fontWeight: "bold",
                fontSize: "19px",
              }}>
                アラートの内容は「本当に報告してもよろしいですか？
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  onClick={() => reportCarvibes()}
                  style={{
                    color: "white",
                    padding: "10px 20px",
                    margin: "0 10px",
                    width: "100%",
                    background:
                      "linear-gradient(89.94deg, #395A37 -0.36%, #2B4773 99.95%)",
                    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.122)",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Report
                </div>

                <div
                  onClick={() => {
                    setReportModalOpen(false);
                    setSelectedCarvibesForReport("");
                  }}
                  style={{
                    color: "white",
                    padding: "10px 20px",
                    margin: "0 10px",
                    width: "100%",
                    background:
                      "linear-gradient(89.94deg, #395A37 -0.36%, #2B4773 99.95%)",
                    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.122)",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Close
                </div>
              </div>
            </div>
          </div>

        </div>) : null}

      {translationAlert ?
        <InformModal
          isOpen={translationAlert}
          title={translationAlert}
          onClose={() => setTranslationAlert('')}
          modalWidth="350px"
          textPadding="8px 0"
        /> : null}

      {deleteCarvibesId ? (
        <div
          className="modal-edit"
          onClick={() => {
            setDeleteCarvibesId("")
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              width: "350px",
              height: "175px",
              textAlign: "center",
              display: deleteCarvibesId ? "block" : "none"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <p style={{
                fontWeight: "bold",
                fontSize: "19px",
              }}>
                本当にこの投稿を削除しますか？
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  onClick={(e) => deleteCarvibes(e, deleteCarvibesId)}
                  style={{
                    color: "white",
                    padding: "10px 20px",
                    margin: "0 10px",
                    width: "100%",
                    background:
                      "linear-gradient(89.94deg, #395A37 -0.36%, #2B4773 99.95%)",
                    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.122)",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  はい
                </div>

                <div
                  onClick={() => setDeleteCarvibesId("")}
                  style={{
                    color: "white",
                    padding: "10px 20px",
                    margin: "0 10px",
                    width: "100%",
                    background:
                      "linear-gradient(89.94deg, #395A37 -0.36%, #2B4773 99.95%)",
                    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.122)",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  いいえ
                </div>
              </div>
            </div>
          </div>

        </div>) : null}

      {props.user && editCarvibesData ? <EditCarvibesModal postData={editCarvibesData} onClose={() => { setEditCarvibesData(null) }} /> : null}

      {/* Loading */}
      {isGeneratingImage && <Loading />}

      {/* Preview Modal */}
      {showPreviewModal && generatedImageUrl ? (
        <div
          className="share-preview-modal-overlay"
          onClick={handleClosePreview}
        >
          <div
            className="share-preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Image Preview */}
            <div className="share-preview-image-container">
              <img
                src={generatedImageUrl}
                alt="Generated share image"
                className="share-preview-image"
              />
            </div>

            {/* Buttons */}
            <div className="share-preview-buttons">
              <div
                onClick={handleClosePreview}
                className="share-preview-button share-preview-button-close"
              >
                Close
              </div>
              <div
                onClick={handleConfirmShare}
                className="share-preview-button share-preview-button-share"
              >
                Share
              </div>
            </div>
          </div>
        </div>
      ) : null}

    </div>
  );
});

export default withRouter(CarvibesCard);
